import { SET_DISPLAY_CARRIERS } from './actionTypes'

export function setDisplayCarriers(displayCarriers) {
  return {
    type: SET_DISPLAY_CARRIERS,
    displayCarriers
  }
}
